"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import PasswordInput from "@/views/accountItems/components/PasswordInput.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
class companySettingController extends UiFormController {
  constructor() {
    super(...arguments);
    this.safe_password = "";
    this.extension_protect = false;
    this.shortmessage_send = true;
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("enterprisesetting.safe_password_input_tip"),
      trigger: "blur"
    }
  ])
], companySettingController.prototype, "safe_password", 2);
let EnterpriseSettings = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.settingController = new companySettingController();
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getCompanySetting();
    });
  }
  getCompanySetting() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v8/enterprise`);
        console.log(response.data);
        this.settingController.extension_protect = response.data.need_cookie_security_code;
        this.settingController.shortmessage_send = !response.data.no_send_shortmessage;
        this.settingController.safe_password = response.data.security_code;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  setCompanySetting() {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v8/enterprise`, {
          "need_cookie_security_code": this.settingController.extension_protect,
          "no_send_shortmessage": !this.settingController.shortmessage_send,
          "security_code": this.settingController.safe_password
        });
        this.$message.success(this.$t("enterprise_setting.edit_success"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Debounce(800)
], EnterpriseSettings.prototype, "setCompanySetting", 1);
EnterpriseSettings = __decorateClass([
  Component({
    components: {
      UiForm,
      PasswordInput
    }
  })
], EnterpriseSettings);
export {
  EnterpriseSettings as default
};
